<template>
  <div class="container">
    <div class="header">
      <div class="title">
        活动管理
        <div class="fansk">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/shouye' }" class="dsadf">
              <span class="dsadf">首页</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>发布管理</el-breadcrumb-item>
            <el-breadcrumb-item>发布</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <el-divider></el-divider>
    </div>
    <el-button size="small" @click="$router.go(-1)"> 返回 </el-button>

    <div class="main">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="130px"
        label-position="left"
        size="small"
        class="form-control"
      >
        <el-form-item label="活动名称" prop="name" class="form-item-width">
          <el-input v-model="form.name" placeholder="请输入活动名称"></el-input>
        </el-form-item>
        <el-form-item label="开展方式" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio
              :label="item.value"
              v-for="item in activityWay"
              :key="item.value"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <template v-if="isEventInformation">
          <!-- 精选 -->
          <template v-if="adminRole">
            <el-form-item label="是否精选" prop="selected">
              <el-radio-group v-model="form.selected">
                <el-radio
                  :label="item.value"
                  v-for="item in [
                    { value: 0, label: '普通' },
                    { value: 1, label: '精选' },
                  ]"
                  :key="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </template>

          <template v-if="form.type == '6'">
            <el-form-item label="资讯类型" prop="is_link">
              <el-radio-group v-model="form.is_link">
                <el-radio
                  :label="item.value"
                  v-for="item in [
                    { value: 0, label: '富文本介绍' },
                    { value: 1, label: '公众号链接' },
                  ]"
                  :key="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <template v-if="form.is_link == 0">
              <el-form-item label="活动介绍" prop="introduce">
                <quill-editor
                  id="myQuillEditor"
                  class="appwrapper"
                  v-model="form.introduce"
                  :rows="3"
                  ref="myQuillEditor"
                  :options="editorOptionByIntroduce"
                  style="width: 50%"
                >
                </quill-editor>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item label="外链地址" prop="introduce">
                <el-input
                  v-model="form.introduce"
                  style="width: 50%"
                  placeholder="请输入外链地址"
                ></el-input>
              </el-form-item>
            </template>
          </template>
          <template v-else>
            <el-form-item label="活动介绍" prop="introduce">
              <quill-editor
                id="myQuillEditor"
                class="appwrapper"
                v-model="form.introduce"
                :rows="3"
                ref="myQuillEditor"
                :options="editorOptionByIntroduce"
                style="width: 50%"
              >
              </quill-editor>
            </el-form-item>
          </template>

          <el-form-item label="宣传图片" prop="pics">
            <MultipleUploadSWithDragort
              :uploadedList.sync="form.pics"
              :uploadMaxLen="10"
              name="pic"
            >
            </MultipleUploadSWithDragort>
            <div class="tip" style="color: #86909c">
              1.第1张图用于新闻列表，继续增加会在活动页上方滚动播放<br />
              2.不填写格使用默认封面，最多建议不超过10张<br />
              3.推荐比例为16:9<br />
            </div>
          </el-form-item>

          <!-- 附件 -->
          <el-form-item label="附件" prop="annex">
            <NoImageFileUpload
              style="margin-right: 12px"
              name="pdf"
              :uploadedList.sync="form.annex"
              :uploadMaxLen="3"
              tip="请上传pdf 文件"
            />
          </el-form-item>
        </template>

        <template v-else>
          <el-form-item label="项目类型" prop="sport_type">
            <el-checkbox-group v-model="form.sport_type">
              <el-checkbox
                v-for="item in sportTypes"
                :label="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="活动时间" prop="act_starttime">
            <el-date-picker
              v-model="form.act_starttime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="选择开始时间"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="form.act_endtime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="选择结束时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="活动地址" prop="address" class="form-item-width">
            <el-input
              v-model="form.address"
              placeholder="请选择活动地址"
              disabled
            >
              <template slot="append">
                <el-button
                  @click="
                    handleSelectPosition({
                      fieldName: 'address',
                      type: 'address',
                    })
                  "
                  size="small"
                  icon="el-icon-location-outline"
                >
                  选择位置
                </el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item
            label="联系人电话"
            type="phoneNumber"
            prop="phone"
            class="form-item-width"
          >
            <el-input
              v-model="form.phone"
              placeholder="请填写联系人电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动介绍" prop="introduce">
            <quill-editor
              id="myQuillEditor"
              class="appwrapper"
              v-model="form.introduce"
              :rows="3"
              ref="myQuillEditor"
              :options="editorOptionByIntroduce"
              style="width: 50%"
            >
            </quill-editor>
          </el-form-item>
          <el-form-item label="宣传图片" prop="pics">
            <MultipleUploadSWithDragort
              :uploadedList.sync="form.pics"
              :uploadMaxLen="10"
              name="pic"
            >
            </MultipleUploadSWithDragort>
            <div class="tip" style="color: #86909c">
              1.第1张图用于新闻列表，继续增加会在活动页上方滚动播放<br />
              2.不填写格使用默认封面，最多建议不超过10张<br />
              3.推荐比例为16:9<br />
            </div>
          </el-form-item>
          <!-- 赛前/赛中/赛后(精彩时刻) -->
          <template v-if="isMatchType">
            <el-form-item label="赛前" prop="act_first_images">
              <MultipleUploadSWithDragort
                :uploadedList.sync="form.act_first_images"
                :uploadMaxLen="20"
                name="pic"
              />
              <div class="tip" style="color: #86909c">
                最多添加 20 张活动照片, 会在活动页面展示
              </div>
            </el-form-item>
            <el-form-item label="赛中" prop="act_second_images">
              <MultipleUploadSWithDragort
                :uploadedList.sync="form.act_second_images"
                :uploadMaxLen="20"
                name="pic"
              />
              <div class="tip" style="color: #86909c">
                最多添加 20 张活动照片, 会在活动页面展示
              </div>
            </el-form-item>
          </template>
          <el-form-item
            :label="isMatchType ? '赛后' : '精彩时刻'"
            prop="act_images"
          >
            <MultipleUploadSWithDragort
              :uploadedList.sync="form.act_images"
              :uploadMaxLen="20"
              name="pic"
            />
            <div class="tip" style="color: #86909c">
              最多添加 20 张活动照片, 会在活动页面展示
            </div>
          </el-form-item>
          <template v-if="isMatchType">
            <el-form-item label="成绩册/秩序册">
              <div
                style="
                  display: flex;
                  justify-content: flex-start;
                  flex-wrap: wrap;
                "
              >
                <NoImageFileUpload
                  style="margin-right: 12px"
                  name="pdf"
                  :uploadedList.sync="form.achievement_pdf"
                  :uploadMaxLen="1"
                  tip="请上传成绩pdf"
                  successTip="成绩册"
                />
                <NoImageFileUpload
                  name="pdf"
                  :uploadedList.sync="form.order_pdf"
                  :uploadMaxLen="1"
                  tip="请上传秩序pdf"
                  successTip="秩序册"
                />
              </div>
            </el-form-item>
          </template>
          <!-- <el-form-item label="参与人数" prop="enroll_num">
            <el-input v-model="form.enroll_num"></el-input>
          </el-form-item>
          <el-form-item label="浏览人数" prop="look_num">
            <el-input v-model="form.look_num"></el-input>
          </el-form-item>
          <el-form-item label="点赞人数" prop="act_like_num">
            <el-input v-model="form.act_like_num"></el-input>
          </el-form-item>
          <el-form-item label="收藏人数" prop="act_follow_num">
            <el-input v-model="form.act_follow_num"></el-input>
          </el-form-item> -->
          <el-form-item label="活动总结" prop="summarize">
            <!-- <el-input
              type="textarea"
              v-model="form.summarize"
              placeholder="请输入活动总结"
              :rows="3"
            ></el-input> -->
            <quill-editor
              id="myQuillEditor2"
              class="appwrapper"
              v-model="form.summarize"
              :rows="3"
              ref="myQuillEditor2"
              :options="editorOption2"
              style="width: 50%"
            >
            </quill-editor>
          </el-form-item>
          <el-form-item label="是否需要报名" prop="enroll_switch">
            <el-radio-group v-model="form.enroll_switch">
              <el-radio label="0">无需报名</el-radio>
              <el-radio label="1">需要报名</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 需要报名的活动新增更多字段 -->
          <template v-if="needMoreFileds">
            <el-form-item label="是否需要实名" prop="user_auth">
              <el-radio-group v-model="form.user_auth">
                <el-radio label="0">否</el-radio>
                <el-radio label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="所需运动币" prop="currency">
              <el-radio-group v-model="form.currency">
                <el-input-number
                  v-model="form.currency"
                  placeholder="所需运动币"
                  style="width: 180px"
                ></el-input-number>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="需要关注协会" prop="join_bus">
              <el-select
                v-model="form.join_bus"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词检索协会"
                :remote-method="need_follow_association_remoteMethod"
                :loading="need_follow_association_loading"
                style="width: 360px"
              >
                <el-option
                  v-for="item in need_follow_association_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="报名是否需要审核" prop="enroll_status">
              <el-radio-group v-model="form.enroll_status">
                <el-radio label="2">无需审核</el-radio>
                <el-radio label="1">需要审核</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="报名人数上限" prop="enroll_limit">
              <el-input-number
                v-model="form.enroll_limit"
                placeholder="请输入报名人数"
                style="width: 180px"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="报名时间" prop="enroll_starttime">
              <el-date-picker
                v-model="form.enroll_starttime"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                placeholder="选择开始时间"
              >
              </el-date-picker>
              至
              <el-date-picker
                v-model="form.enroll_endtime"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                placeholder="选择结束时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="活动分组" prop="group_switch">
              <el-radio-group v-model="form.group_switch">
                <el-radio label="0"> 不设分组 </el-radio>
                <el-radio label="1"> 自定义分组 </el-radio>
              </el-radio-group>
              <!-- 分组操作 -->
              <template v-if="needGrouping">
                <div class="group-form" style="display: flex">
                  <el-input
                    v-model="groupForm.name"
                    placeholder="组名"
                    size="small"
                    style="margin-right: 8px; width: 120px"
                    clearable
                    :disabled="!groupAllowChangeFlag"
                  ></el-input>
                  <el-input-number
                    placeholder="人数"
                    size="small"
                    clearable
                    v-model="groupForm.number"
                    controls-position="right"
                    style="margin-right: 8px; width: 120px"
                    :min="1"
                    :disabled="!groupAllowChangeFlag"
                  ></el-input-number>
                  <el-input-number
                    placeholder="最小年龄"
                    size="small"
                    clearable
                    v-model="groupForm.ageStart"
                    controls-position="right"
                    style="margin-right: 8px; width: 120px"
                    :min="1"
                    :max="100"
                    :disabled="!groupAllowChangeFlag"
                  ></el-input-number>
                  <el-input-number
                    placeholder="最大年龄"
                    size="small"
                    clearable
                    v-model="groupForm.ageEnd"
                    controls-position="right"
                    style="margin-right: 8px; width: 120px"
                    :min="1"
                    :max="100"
                    :disabled="!groupAllowChangeFlag"
                  ></el-input-number>
                  <el-select
                    v-model="groupForm.sex"
                    placeholder="选择性别"
                    size="small"
                    style="margin-right: 8px; width: 120px"
                    clearable
                    :disabled="!groupAllowChangeFlag"
                  >
                    <el-option label="不限" value="不限" />
                    <el-option label="男" value="男" />
                    <el-option label="女" value="女" />
                  </el-select>
                  <el-button
                    :disabled="!groupAllowChangeFlag"
                    @click="handleGroupAdd"
                  >
                    添加
                  </el-button>
                </div>
                <div class="group-list">
                  <div
                    class="group-item"
                    v-for="(group, gIndex) in groupData"
                    :key="gIndex"
                  >
                    <el-tag
                      :closable="groupAllowChangeFlag"
                      :type="groupAllowChangeFlag ? '' : 'info'"
                      :disable-transitions="false"
                      style="margin: 10px 10px 0 0"
                      @close="handleGroupDel(group, gIndex)"
                    >
                      {{ group.title }}
                    </el-tag>
                  </div>
                </div>
              </template>
            </el-form-item>

            <el-form-item label="活动签到">
              <el-radio
                v-model="isNotSignin"
                :label="true"
                @input="inputIsNotSignin"
              >
                无需签到
              </el-radio>
              <el-radio
                v-for="(item, index) in signInList"
                :key="item.value"
                v-model="form.signin_type[index]"
                :label="item.value"
                @click.native.prevent="clickSigninType(index)"
              >
                {{ item.label }}
              </el-radio>
            </el-form-item>
            <!-- 选择签到时, 需要存储签到时间, 选择定位签到需要额外存储距离位置范围  -->
            <template v-if="!isNotSignin">
              <el-form-item label="签到时间" prop="signin_starttime">
                <el-date-picker
                  v-model="form.signin_starttime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  placeholder="选择开始时间"
                >
                </el-date-picker>
                至
                <el-date-picker
                  v-model="form.signin_endtime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  placeholder="选择结束时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                label="签到位置"
                prop="signin_address"
                class="form-item-width"
                v-if="form.signin_type.indexOf('1') > -1"
              >
                <el-input
                  disabled
                  v-model="form.signin_address"
                  placeholder="请选择定位签到位置"
                >
                  <template slot="append">
                    <el-button
                      @click="
                        handleSelectPosition({
                          fieldName: 'signin_address',
                          type: 'address,distance',
                        })
                      "
                      size="small"
                      icon="el-icon-location-outline"
                    >
                      选择位置
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
            </template>
            <el-form-item label="活动签退">
              <el-radio
                v-model="isNotSignout"
                :label="true"
                @input="inputIsNotSignout"
              >
                无需签退
              </el-radio>
              <el-radio
                v-for="(item, index) in signOutList"
                :key="item.value"
                v-model="form.signout_type[index]"
                :label="item.value"
                @click.native.prevent="clickSignoutType(index)"
              >
                {{ item.label }}
              </el-radio>
            </el-form-item>
            <!-- 选择签退时, 需要存储签退时间, 选择定位签退需要额外存储距离位置范围 -->
            <template v-if="!isNotSignout">
              <el-form-item label="签退时间" prop="signout_starttime">
                <el-date-picker
                  v-model="form.signout_starttime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  placeholder="选择开始时间"
                >
                </el-date-picker>
                至
                <el-date-picker
                  v-model="form.signout_endtime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  placeholder="选择结束时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                label="签退位置"
                prop="signout_address"
                class="form-item-width"
                v-if="form.signout_type.indexOf('1') > -1"
              >
                <el-input
                  disabled
                  v-model="form.signout_address"
                  placeholder="请选择定位签退位置"
                >
                  <template slot="append">
                    <el-button
                      @click="
                        handleSelectPosition({
                          fieldName: 'signout_address',
                          type: 'address,distance',
                        })
                      "
                      size="small"
                      icon="el-icon-location-outline"
                    >
                      选择位置
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
            </template>
            <el-form-item label="直播地址" prop="live_link">
              <div>
                <el-radio-group v-model="form.live_switch">
                  <el-radio label="0">无直播</el-radio>
                  <el-radio label="1">有直播</el-radio>
                </el-radio-group>
              </div>
              <template v-if="form.live_switch == 1">
                <div>
                  <el-radio-group v-model="form.live_type">
                    <el-radio label="1">视频</el-radio>
                    <!-- <el-radio label="2">图文</el-radio> -->
                  </el-radio-group>
                </div>
                <div>
                  <el-input
                    class="form-item-width"
                    v-model="form.live_link"
                    placeholder="请输入直播地址"
                  ></el-input>
                </div>
              </template>
            </el-form-item>
          </template>
          <!-- 自定义收集信息 -->
          <el-form-item label="自定义收集信息" prop="custom_fields">
            <div class="custom_fields-form" style="display: flex">
              <el-input
                v-model="customFieldsValue"
                placeholder="输入自定义信息名称"
                size="small"
                style="margin-right: 8px; width: 220px"
                clearable
              ></el-input>
              <el-button
                size="small"
                type="primary"
                @click="handleCustomFieldsAdd"
              >
                确定
              </el-button>
            </div>
            <div class="custom_fields-list">
              <div
                class="custom_fields-item"
                v-for="(field, fIndex) in form.custom_fields"
                :key="fIndex"
              >
                <el-tag
                  closable
                  :disable-transitions="false"
                  style="margin: 10px 10px 0 0"
                  @close="handleCustomFieldsDelete(field, fIndex)"
                >
                  {{ field.name }}
                </el-tag>
              </div>
            </div>
          </el-form-item>
        </template>
      </el-form>
      <el-divider></el-divider>
      <div class="opera">
        <el-button type="primary" @click="handleRelease">发布</el-button>
        <el-button v-if="form.is_status === 0" @click="handleSaveDraft">
          保存为草稿
        </el-button>
      </div>
    </div>
    <SearchAddress ref="searchAddressRef" @onConfirm="onSearchAddressConfirm" />

    <div class="block-none">
      <el-upload
        class="avatar-uploader1"
        ref="upload_1"
        :action="
          editorImgOrVideo === 'img'
            ? 'https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic'
            : 'https://ydmxhapi.yundongm.cn:8099/service/admin/uploadvideo'
        "
        :on-progress="progress"
        :on-success="uploadSuccess"
        :limit="1"
        :before-upload="
          editorImgOrVideo === 'img' ? $beforeUploadImage : $beforeUploadVideo
        "
        :on-exceed="handleExceed"
        list-type="picture"
        :data="{ token: token }"
        :name="editorImgOrVideo === 'img' ? 'pic' : 'video'"
        :shrow-file-list="false"
      >
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
    </div>

    <div class="block-none">
      <el-upload
        class="avatar-uploader2"
        ref="upload_2"
        :action="
          editorImgOrVideo2 === 'img'
            ? 'https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic'
            : 'https://ydmxhapi.yundongm.cn:8099/service/admin/uploadvideo'
        "
        :on-progress="progress"
        :on-success="uploadSuccess2"
        :limit="1"
        :before-upload="
          editorImgOrVideo2 === 'img' ? $beforeUploadImage : $beforeUploadVideo
        "
        :on-exceed="handleExceed"
        list-type="picture"
        :data="{ token: token }"
        :name="editorImgOrVideo2 === 'img' ? 'pic' : 'video'"
        :shrow-file-list="false"
      >
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import SearchAddress from "@/components/Amap/SearchAddress.vue";
import MultipleUploadSWithDragort from "@/components/MultipleUploadWithDragSort/index.vue";
import NoImageFileUpload from "@/components/NoImageFileUpload/index.vue";
// import NoImageFileMultiUpload from "@/components/NoImageFileMultiUpload/index.vue";

import {
  ACTIVITY_WAY,
  EditorToolbarOptions,
  EditorToolbarOptions2,
} from "./constant";

import { getBusinessSportTypeList, sxhList } from "@/api/shangxiehui";
import { addAct, actview, actUpdate } from "@/api/tiezi";
import { addActiveGroup, delActiveGroup } from "@/api/huodongfenzu";
import { adminInfo } from "@/api/login";

export default {
  data() {
    return {
      admin: {},
      need_follow_association_loading: false,
      need_follow_association_options: [],
      editId: "",
      activityWay: ACTIVITY_WAY,
      form: {
        selected: 0,
        user_auth: "0",
        currency: 0,
        join_bus: [],
        type: "4", //  开展方式
        is_link: 0, //  资讯类型 0 即富文本 1 外链H5(公众号
        enroll_switch: "0", //  是否需要报名
        introduce: "",
        pics: [], //  宣传图片
        act_images: [], //  精彩时刻
        group_switch: "0", //  是否需要分组
        signin_type: [], //  签到
        signout_type: [], //  签退
        enroll_status: "2", //  活动报名是否需要审核
        live_switch: "0", //  直播地址
        live_type: "1",
        sport_type: [],
        enroll_limit: 999, //  报名人数
        is_status: 0, //  草稿标识
        custom_fields: [], //  自定义信息字段
        achievement_pdf: [],
        order_pdf: [],
      },
      groupForm: {},
      groupData: [], //  组别数据
      customFieldsValue: "",
      groupAllowChangeFlag: true, // 草稿未审核通过阶段可编辑组别
      /** 签到签退相关 start*/
      isNotSignin: true,
      signinType: ["", "", ""],
      signInList: [
        {
          label: "定位签到",
          value: "1",
        },
        {
          label: "扫码签到",
          value: "2",
        },
        {
          label: "亮码签到",
          value: "3",
        },
      ],
      signOutList: [
        {
          label: "定位签退",
          value: "1",
        },
        {
          label: "扫码签退",
          value: "2",
        },
        {
          label: "亮码签退",
          value: "3",
        },
      ],
      signintime: [], //  签到时间
      signouttime: [], //  签退时间
      isNotSignout: true,
      /** 签到签退相关 end*/
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择开展方式", trigger: "blur" }],
        sport_type: [
          { required: true, message: "请选择项目类型", trigger: "blur" },
        ],
        enroll_switch: [
          { required: true, message: "请选择是否需要报名", trigger: "blur" },
        ],
        enroll_limit: [
          { required: true, message: "请填写报名人数", trigger: "blur" },
        ],
        act_starttime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        address: [
          { required: true, message: "请选择活动地址", trigger: "change" },
        ],
        selected: [
          { required: true, message: "请选择精选/普通", trigger: "blur" },
        ],
        is_link: [
          { required: true, message: "请选择资讯类型", trigger: "blur" },
        ],
        introduce: [
          { required: true, message: "请输入活动介绍", trigger: "blur" },
        ],
        signin_starttime: [
          { required: true, message: "请选择签到时间", trigger: "change" },
        ],
        signin_address: [
          { required: true, message: "请选择签到位置", trigger: "change" },
        ],
        signout_starttime: [
          { required: true, message: "请选择签退时间", trigger: "change" },
        ],
        signout_address: [
          { required: true, message: "请选择签退位置", trigger: "change" },
        ],
        enroll_starttime: [
          { required: true, message: "请选择报名时间", trigger: "change" },
          // { validator: checkActTime, trigger: "blur" },
        ],
      },
      sportTypes: [],
      actTime: [], //  活动时间
      enrollTime: [], //  活动报名时间
      addressSource: "",
      token: sessionStorage.getItem("token"),
      // 富文本编辑器配置
      editorImgOrVideo: "img",
      editorOptionByIntroduce: {
        placeholder: "请使用文字或图片介绍本次活动",
        theme: "snow",
        modules: {
          toolbar: {
            container: EditorToolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  this.editorImgOrVideo = "img";
                  console.log("_editorOption image", this.editorImgOrVideo);
                  // 触发input框选择图片文件
                  document.querySelector(".avatar-uploader1 input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              video: (value) => {
                if (value) {
                  this.editorImgOrVideo = "video";
                  console.log("_editorOption video", this.editorImgOrVideo);
                  // debugger;
                  // 触发input框选择视频文件
                  document.querySelector(".avatar-uploader1 input").click();
                } else {
                  this.quill.format("video", false);
                }
              },
            },
          },
        },
      },
      editorImgOrVideo2: "img",
      editorOption2: {
        placeholder:
          "可在活动中、活动后添加文字或图片内容, 对活动进行总结, 展示风采",
        theme: "snow",
        modules: {
          toolbar: {
            container: EditorToolbarOptions2, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  console.log("_editorOption2 handler");

                  this.editorImgOrVideo2 = "img";
                  // 触发input框选择图片文件
                  document.querySelector(".avatar-uploader2 input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              video: (value) => {
                if (value) {
                  this.editorImgOrVideo2 = "video";
                  // 触发input框选择视频文件
                  document.querySelector(".avatar-uploader2 input").click();
                } else {
                  this.quill.format("video", false);
                }
              },
            },
          },
        },
      },
    };
  },
  computed: {
    adminRole() {
      return this.admin.type === 0;
    },
    /** 开展方式是资讯*/
    isEventInformation() {
      return this.form.type === "6";
    },
    /** 开展方式是赛事*/
    isMatchType() {
      return this.form.type === "1";
    },
    needMoreFileds() {
      return this.form.enroll_switch === "1"; //  活动是否需要报名 | 需要报名活动需要填写更多字段
    },
    needGrouping() {
      return this.form.group_switch === "1"; //  报名 -> 设定分组 | 展示分组操作字段
    },
  },
  components: {
    SearchAddress,
    MultipleUploadSWithDragort,
    NoImageFileUpload,
    // NoImageFileMultiUpload,
  },
  methods: {
    async initFollowAssociationList() {
      const resp = await sxhList({ pagesize: 1000 });
      this.need_follow_association_list = this.need_follow_association_options =
        resp.data.list.map((item) => ({
          value: item.id,
          label: item.org_com,
        }));
      // console.log(
      //   "_this.need_follow_association_list",
      //   this.need_follow_association_list
      // );
    },
    need_follow_association_remoteMethod(query) {
      if (query !== "") {
        this.need_follow_association_loading = true;
        setTimeout(() => {
          this.need_follow_association_loading = false;
          this.need_follow_association_options =
            this.need_follow_association_list.filter((item) => {
              return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
            });
        }, 200);
      } else {
        this.need_follow_association_options = [];
      }
    },
    /** 发布*/
    handleRelease() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const form = cloneDeep(this.form);

          // 图片处理 ['xxx','xxx2'] => [{name:'xxx'},{name:'xxx2'}]
          if (form.pics) {
            form.pics = JSON.stringify(form.pics.map((pic) => ({ name: pic })));
          }
          if (form.act_images) {
            form.act_images = JSON.stringify(
              form.act_images.map((pic) => ({ name: pic }))
            );
          }
          if (form.act_first_images) {
            form.act_first_images = JSON.stringify(
              form.act_first_images.map((pic) => ({ name: pic }))
            );
          }
          if (form.act_second_images) {
            form.act_second_images = JSON.stringify(
              form.act_second_images.map((pic) => ({ name: pic }))
            );
          }
          //  pdf处理
          if (form.achievement_pdf) {
            form.achievement_pdf = form.achievement_pdf[0] || "";
          }
          if (form.order_pdf) {
            form.order_pdf = form.order_pdf[0] || "";
          }
          if (form.annex) {
            form.annex = form.annex.join(",") || "";
          }

          // 项目类型处理
          if (form.sport_type.length) {
            form.sport_type = form.sport_type.join(",");
          }
          //  签到签退处理
          let signin_type = "0";
          if (!this.isNotSignin) {
            signin_type = form.signin_type.join(",");
          }
          let signout_type = "0";
          if (!this.isNotSignout) {
            signout_type = form.signout_type.join(",");
          }
          form.signin_type = signin_type;
          form.signout_type = signout_type;

          //  关注协会处理
          if (form.join_bus && Array.isArray(form.join_bus)) {
            form.join_bus = form.join_bus.join(",");
          }

          // 活动类型
          if (form.sport_type && Array.isArray(form.sport_type)) {
            form.sport_type = form.sport_type.join(",");
          }

          // 发布活动时, 添加 is_status = 1
          form.is_status = 1;

          // console.log("_save", form)
          // return
          // console.log("_handleRelease", form, "_editId", this.editId);
          // 编辑时, 添加 id
          const editId = this.editId;
          if (editId) form.id = editId;

          const saveResp = editId ? await actUpdate(form) : await addAct(form);
          const { result, data, msg } = saveResp.data;
          console.log("_", msg);

          if (result === 1) {
            const h = this.$createElement;
            // 活动保存成功, 存在组别, 额外存储组别信息 * 注意, 编辑时不再重新循环添加分组
            if (!editId) {
              if (this.form.group_switch == 1) {
                this.groupData.forEach(async (item) => {
                  await addActiveGroup({
                    token: this.token,
                    act_id: data.act_id,
                    title: item.title,
                  });
                });
                // this.$message.success(`${msg}`);
                this.$notify({
                  title: "发布活动提示",
                  message: h("i", { style: "color: #67c23a" }, msg),
                  type: "success",
                });
                this.$router.go(-1);
              } else {
                // this.$message.success(`${msg}`);
                this.$notify({
                  title: "发布活动提示",
                  message: h("i", { style: "color: #67c23a" }, msg),
                  type: "success",
                });
                this.$router.go(-1);
              }
            } else {
              // this.$message.success(`${msg}`);
              this.$notify({
                title: "发布活动提示",
                message: h("i", { style: "color: #67c23a" }, msg),
                type: "success",
              });
              this.$router.go(-1);
            }
          } else {
            this.$message.error(msg);
          }
          console.log("_saveResp", saveResp);
        }
      });
    },
    /** 保存为草稿*/
    async handleSaveDraft() {
      this.$refs.form.clearValidate();
      const form = cloneDeep(this.form);

      // 图片处理 ['xxx','xxx2'] => [{name:'xxx'},{name:'xxx2'}]
      if (form.pics) {
        form.pics = JSON.stringify(form.pics.map((pic) => ({ name: pic })));
      }
      if (form.act_images) {
        form.act_images = JSON.stringify(
          form.act_images.map((pic) => ({ name: pic }))
        );
      }
      if (form.act_first_images) {
        form.act_first_images = JSON.stringify(
          form.act_first_images.map((pic) => ({ name: pic }))
        );
      }
      if (form.act_second_images) {
        form.act_second_images = JSON.stringify(
          form.act_second_images.map((pic) => ({ name: pic }))
        );
      }
      //  pdf处理
      if (form.achievement_pdf) {
        form.achievement_pdf = form.achievement_pdf[0] || "";
      }
      if (form.order_pdf) {
        form.order_pdf = form.order_pdf[0] || "";
      }
      if (form.annex) {
        form.annex = form.annex.join(",");
      }

      // 项目类型处理
      if (form.sport_type) {
        form.sport_type = form.sport_type.join(",");
      }
      //  签到签退处理
      let signin_type = "0";
      if (!this.isNotSignin) {
        signin_type = form.signin_type.join(",");
      }
      let signout_type = "0";
      if (!this.isNotSignout) {
        signout_type = form.signout_type.join(",");
      }
      form.signin_type = signin_type;
      form.signout_type = signout_type;

      //  关注协会处理
      if (form.join_bus && Array.isArray(form.join_bus)) {
        form.join_bus = form.join_bus.join(",");
      }

      // 保存草稿时, 添加 is_status = 0
      form.is_status = 0;

      // 编辑时, 添加 id
      const editId = this.editId;
      if (editId) form.id = editId;

      const saveResp = editId ? await actUpdate(form) : await addAct(form);

      const { result, data, msg } = saveResp.data;
      if (result === 1) {
        // 活动保存成功, 存在组别, 额外存储组别信息 * 注意, 编辑时不再重新循环添加分组
        if (!this.editId) {
          if (this.form.group_switch == 1) {
            this.groupData.forEach(async (item) => {
              await addActiveGroup({
                token: this.token,
                act_id: data.act_id,
                title: item.title,
              });
            });
            this.$message.success(`保存草稿成功`);
            this.$router.go(-1);
          } else {
            this.$message.success(`保存草稿成功`);
            this.$router.go(-1);
          }
        } else {
          this.$message.success(`保存草稿成功`);
          this.$router.go(-1);
        }
      } else {
        this.$message.error(msg);
      }
      console.log("_saveResp", saveResp);
    },
    //  添加分组
    async handleGroupAdd() {
      const groupForm = cloneDeep(this.groupForm);
      // console.log("_handleGroupAdd", groupForm.ageStart, groupForm.ageEnd);
      if (groupForm.ageStart && groupForm.ageEnd) {
        if (~~groupForm.ageEnd < ~~groupForm.ageStart) {
          this.$message({
            message: "年龄选择有误",
            type: "error",
          });
          return;
        }
        groupForm.age = `${groupForm.ageStart}-${groupForm.ageEnd}`;
      } else {
        this.$message({
          message: "请选择年龄",
          type: "error",
        });
        return;
      }

      if (
        groupForm.name &&
        groupForm.number &&
        groupForm.age &&
        groupForm.sex
      ) {
        groupForm.title = `${groupForm.name},${groupForm.number},${groupForm.age},${groupForm.sex}`;
        this.groupData.push(groupForm);

        // 编辑时, 即使发送接口完成分组添加
        if (this.editId) {
          const addGroupRes = await addActiveGroup({
            token: this.token,
            act_id: this.editId,
            title: groupForm.title,
          });
          console.log("_addGroupRes", addGroupRes);
        }
        console.log("_handleGroupAdd", groupForm, "groupData", this.groupData);
        this.groupForm = {};
      } else {
        this.$message({
          message: "请完成组别信息填写",
          type: "error",
        });
      }
    },
    //  删除分组
    async handleGroupDel(group, index) {
      this.groupData.splice(index, 1);
      // 编辑时, 即使发送接口完成分组删除
      if (this.editId) {
        const delGroupRes = await delActiveGroup({
          id: group.id,
          token: this.token,
        });
        console.log("_delGroupRes", delGroupRes);
      }
    },
    //  自定义收集信息添加
    handleCustomFieldsAdd() {
      if (!this.customFieldsValue.trim()) {
        return this.$message.error("请输入收集信息字段名称!");
      }
      const form = cloneDeep(this.form);
      form.custom_fields.push({ name: this.customFieldsValue });
      this.form = form;
      setTimeout(() => {
        this.customFieldsValue = "";
      }, 100);
    },
    handleCustomFieldsDelete(field, index) {
      const form = cloneDeep(this.form);
      form.custom_fields.splice(index, 1);
      this.form = form;
    },
    //  签到签退相关 start
    inputIsNotSignin() {
      this.form.signin_type = ["", "", ""];
    },
    inputIsNotSignout() {
      this.form.signout_type = ["", "", ""];
    },
    clickSigninType(index) {
      this.$set(
        this.form.signin_type,
        index,
        this.form.signin_type[index] ? "" : this.signInList[index].value
      );
      this.isNotSignin = !this.form.signin_type.find((item) => item);
    },
    clickSignoutType(index) {
      this.$set(
        this.form.signout_type,
        index,
        this.form.signout_type[index] ? "" : this.signOutList[index].value
      );
      this.isNotSignout = !this.form.signout_type.find((item) => item);
    },
    //  签到签退相关 end

    /** 初始化表单信息 */
    async initFormData() {
      const id = this.editId;
      const detailResp = await actview({
        token: this.token,
        id,
      });
      const detail = detailResp.data;
      if (detail.result === 1) {
        // 数据初始化
        let sport_type;
        if (detail.sport_type) {
          sport_type = detail.sport_type.split(",").map((type) => Number(type));
        } else {
          sport_type = [];
        }
        // 图片
        let pics = detail.pics.map((pic) => pic.name);
        let act_images = detail.act_images.map((pic) => pic.name);
        let act_first_images = detail.act_first_images.map((pic) => pic.name);
        let act_second_images = detail.act_second_images.map((pic) => pic.name);

        console.log("_detail", detail);
        //  关注协会处理
        let join_bus = [];
        if (detail.join_bus) {
          join_bus = detail.join_bus.split(",").map((item) => item - 0);
        }
        console.log("_join_bus", join_bus);
        let user_auth = String(detail.user_auth);

        // 签到相关
        let signin_type,
          signin_starttime,
          signin_endtime,
          signin_address,
          signin_distance,
          signin_lat,
          signin_lng;
        if (detail.signin_type.indexOf("0") > -1) {
          this.isNotSignin = true;
          signin_type = ["", "", ""];
        } else {
          this.isNotSignin = false;
          signin_type = detail.signin_type.toString().split(",");
          signin_starttime = detail.signin_starttime;
          signin_endtime = detail.signin_endtime;
          signin_address = detail.signin_address;
          signin_distance = detail.signin_distance;
          signin_lat = detail.signin_lat;
          signin_lng = detail.signin_lng;
        }
        //  签退相关
        let signout_type,
          signout_starttime,
          signout_endtime,
          signout_address,
          signout_distance,
          signout_lat,
          signout_lng;
        if (detail.signout_type.indexOf("0") > -1) {
          this.isNotSignout = true;
          signout_type = ["", "", ""];
        } else {
          this.isNotSignout = false;
          signout_type = detail.signout_type.toString().split(",");
          signout_starttime = detail.signout_starttime;
          signout_endtime = detail.signout_endtime;
          signout_address = detail.signout_address;
          signout_distance = detail.signout_distance;
          signout_lat = detail.signout_lat;
          signout_lng = detail.signout_lng;
        }
        // 分组
        this.groupData = detail.group_list.map((group) => ({
          title: group.title,
          id: group.id,
          name: group.list[0],
          number: group.list[1],
          age: group.list[2],
          sex: group.list[3],
        }));
        //  组别是否允许被编辑
        if (detail.is_status === 0 || detail.is_status === 1) {
          this.groupAllowChangeFlag = true; //  草稿和待审核阶段允许修改
        } else {
          this.groupAllowChangeFlag = false; // 其它阶段不允许修改
        }
        //  报名相关
        let enroll_starttime, enroll_endtime;
        if (detail.enroll_switch === "1") {
          enroll_starttime = detail.enroll_starttime;
          enroll_endtime = detail.enroll_endtime;
        }
        //  活动时间
        let act_starttime, act_endtime;
        act_starttime = detail.act_starttime;
        act_endtime = detail.act_endtime;

        //  pdf
        let achievement_pdf = [];
        if (detail.achievement_pdf) {
          achievement_pdf = [detail.achievement_pdf];
        }

        let order_pdf = [];
        if (detail.order_pdf) {
          order_pdf = [detail.order_pdf];
        }

        let annex = [];
        if (detail.annex) {
          annex = detail.annex.split(",");
        }
        // console.log("_achievement_pdf", achievement_pdf);
        // console.log("_order_pdf", order_pdf);

        this.form = {
          selected: Number(detail.selected || 0),
          join_bus, //  需要关注协会
          user_auth, //  需要实人认证
          currency: detail.currency, //  需要运动币
          name: detail.name, //  活动名称
          type: detail.type, //  开展方式
          is_link: detail.is_link, // 资讯类型
          sport_type, // 项目类型
          enroll_switch: detail.enroll_switch, //  是否需要报名
          enroll_status: detail.enroll_status, //  报名是否需要审核
          enroll_limit: detail.enroll_limit, //  报名人数上限
          enroll_starttime: enroll_starttime, //  报名开始时间
          enroll_endtime: enroll_endtime, //  报名结束时间
          act_starttime, //  活动开始时间
          act_endtime, //  活动结束时间
          address: detail.address, //  活动地址
          longitude: detail.longitude, //  活动地址经度
          latitude: detail.latitude, //  活动地址纬度
          introduce: detail.introduce, //  活动介绍
          phone: detail.phone, // 联系人电话
          pics, //  宣传图片
          act_images, //  精彩时刻
          act_first_images, //赛前
          act_second_images, // 赛中
          achievement_pdf, // 成绩册
          order_pdf, //  秩序册
          annex, // 其他附件(资讯专属)
          // enroll_num: detail.enroll_num, //参与人员
          // look_num: detail.look_num, //浏览量
          // act_like_num: detail.act_like_num, // 点赞数
          // act_follow_num: detail.act_follow_num, // 收藏
          summarize: detail.summarize, //  活动总结
          group_switch: detail.group_switch, //  是否需要分组
          signin_type, //  签到
          signin_starttime, //  签到开始时间
          signin_endtime, //  签到结束时间
          signin_address, //  签到地址
          signin_distance, //  签到范围
          signin_lng, //  签到位置纬度
          signin_lat, //  签到位置经度
          signout_type, //  签退
          signout_starttime, //  签退开始时间
          signout_endtime, //  签退结束时间
          signout_address, //  签退定位地址
          signout_distance, //  签退定位范围
          signout_lat, //  签退纬度
          signout_lng, //  签退经度
          live_switch: detail.live_switch, //  有无直播
          live_type: detail.live_type, //  直播类型
          live_link: detail.live_link, //  直播地址
          custom_fields: detail.custom_fields, // 自定义信息字段
          is_status: detail.is_status, //  草稿标识字段
        };

        console.log("_this.form", this.form);
      }
    },

    /** 初始化活动类型*/
    async initSportTypes() {
      try {
        const resultResp = await getBusinessSportTypeList({
          limit: -1,
          token: this.token,
        });
        const { data, result } = resultResp.data;
        if (result === 1) {
          this.sportTypes = data.map((item) => ({
            value: item.id,
            label: item.title,
          }));
        } else {
          this.sportTypes = [];
        }
        // 活动默认选中活动类型
        let sportType = this.sportTypes.find((sport, index) => index === 0);
        this.form = { ...this.form, sport_type: [sportType.value] };
      } catch (error) {
        console.log("运动类型初始失败");
      }
    },

    /** 选择位置*/
    handleSelectPosition({ fieldName, type }) {
      this.addressSource = fieldName;
      console.log("_handleSelectPosition");
      const form = this.form;
      switch (fieldName) {
        case "address":
          // 选择活动地址
          this.$refs.searchAddressRef.init({
            address: form.address,
            lng: form.longitude,
            lat: form.latitude,
            type,
          });
          break;
        case "signin_address":
          // 选择定位签到地址
          this.$refs.searchAddressRef.init({
            address: form.signin_address,
            lng: form.signin_lng,
            lat: form.signin_lat,
            distance: form.signin_distance,
            type,
          });
          break;
        case "signout_address":
          // 选择定位签退地址
          this.$refs.searchAddressRef.init({
            address: form.signout_address,
            lng: form.signout_lng,
            lat: form.signout_lat,
            distance: form.signout_distance,
            type,
          });
          break;
        default:
          console.log("地址选择其它");
      }
    },
    /** 选择地址回调*/
    onSearchAddressConfirm(posData) {
      const addressSource = this.addressSource;
      const form = cloneDeep(this.form);
      switch (addressSource) {
        case "address": //  处理地址选择
          form.address = posData.address;
          form.latitude = posData.lat;
          form.longitude = posData.lng;
          break;
        case "signin_address": //  处理签到地址选择
          form.signin_address = posData.address;
          form.signin_lat = posData.lat;
          form.signin_lng = posData.lng;
          form.signin_distance = posData.distance;
          break;
        case "signout_address": //  处理签退地址选择
          form.signout_address = posData.address;
          form.signout_lat = posData.lat;
          form.signout_lng = posData.lng;
          form.signout_distance = posData.distance;
          break;
        default:
          console.log("无效选择");
      }
      console.log("_onSearchAddressConfirm", posData);
      this.form = form;
      this.addressSource = "";
    },

    onActTimeChange(values) {
      // console.log("活动时间:", values);
      const form = cloneDeep(this.form);
      if (values) {
        form.act_starttime = values[0];
        form.act_endtime = values[1];
      } else {
        form.act_starttime = "";
        form.act_endtime = "";
      }
      this.form = form;
    },
    onEnrollTimeChange(values) {
      // console.log("活动报名时间:", values);
      const form = cloneDeep(this.form);
      if (values) {
        form.enroll_starttime = values[0];
        form.enroll_endtime = values[1];
      } else {
        form.enroll_starttime = "";
        form.enroll_endtime = "";
      }
      this.form = form;
    },
    onSignintimeChange(values) {
      // console.log("签到时间:", values);
      const form = cloneDeep(this.form);
      if (values) {
        form.signin_starttime = values[0];
        form.signin_endtime = values[1];
      } else {
        form.signin_starttime = "";
        form.signin_endtime = "";
      }
      this.form = form;
    },
    onSignouttimeChange(values) {
      // console.log("签退时间:", values);
      const form = cloneDeep(this.form);
      if (values) {
        form.signout_starttime = values[0];
        form.signout_endtime = values[1];
      } else {
        form.signout_starttime = "";
        form.signout_endtime = "";
      }
      this.form = form;
    },
    /*** 富文本上传相关 ****/
    beforeUpload(file) {
      const promise = new Promise((resolve) => {
        this.$nextTick(function () {
          resolve(true);
        });
      });
      return promise; // 通过返回一个promis对象解决
    },
    progress(event, file, fileList) {
      // console.log("event", event, "file", file, "fileList", fileList);
      // this.addquery.font_url.push({ name: file })
    },
    // 文件数量过多时提醒
    handleExceed() {
      // this.$message({ type: 'info', message: '最多支持5个附件上传' })
    },
    uploadSuccess(res, file) {
      console.log("_uploadSuccess");
      this.$refs.upload_1.clearFiles();
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      // 如果上传成功
      if (res.result === 1) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        if (this.editorImgOrVideo === "img") {
          quill.insertEmbed(length, "image", res.pic_url);
          // 调整光标到最后
          quill.setSelection(length + 1);
        } else {
          quill.insertEmbed(length, "video", res.video_url);
          // 调整光标到最后
          quill.setSelection(length + 1);
        }

        this.$forceUpdate();
      } else {
        this.$message.error("图片插入失败");
      }
    },
    uploadSuccess2(res, file) {
      // console.log("_uploadSuccess2");
      this.$refs.upload_2.clearFiles();
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor2.quill;
      // 如果上传成功
      if (res.result === 1) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        if (this.editorImgOrVideo2 === "img") {
          quill.insertEmbed(length, "image", res.pic_url);
          // 调整光标到最后
          quill.setSelection(length + 1);
        } else {
          quill.insertEmbed(length, "video", res.video_url);
          // 调整光标到最后
          quill.setSelection(length + 1);
        }

        this.$forceUpdate();
      } else {
        this.$message.error("图片插入失败");
      }
    },
  },
  async created() {
    await this.initSportTypes();
    await this.initFollowAssociationList();
    const editId = this.$route.query.id;
    if (editId) {
      this.editId = editId;
      await this.initFormData();
    }

    // 登录用户信息
    adminInfo({
      token: sessionStorage.getItem("token"),
    }).then(({ data: res }) => {
      this.admin = res;
    });
  },
};
</script>

<style scoped lang="less">
.container {
  .main {
    padding: 12px 0 48px 0;
  }
}

.header {
  display: flex;
  flex-direction: column;

  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }

    .dsadf {
      color: #3d9aff;
    }
  }

  & /deep/ .el-divider--horizontal {
    margin: 8px 0;
  }
}

.form-item-width {
  max-width: 550px;
}

.block-none {
  display: none;
}

.group-form {
}
.group-list {
  display: flex;
  flex-wrap: wrap;
}

.custom_fields-list {
  display: flex;
  flex-wrap: wrap;
}
</style>
